import { Icon } from "web/components"

export default function SetDateIcon({ handleSetDate }) {
  return (
    <span className="hidden text-gray-600 group-hover:flex">
      {handleSetDate && (
        <Icon
          size="small"
          name="calendar"
          className="mr-1 cursor-pointer"
          onClick={handleSetDate}
        />
      )}
    </span>
  )
}
